/* eslint-disable no-console */
import { LogLevel } from '@azure/msal-browser';
import { getDnsUrl } from '../../../settings';

export const msalConfig = async (msClientId: string, msTenantId: string) => {
  const currenthost = await getDnsUrl();
  console.log('Smartsell Host', currenthost);

  return {
    auth: {
      clientId: msClientId,
      authority: `https://login.microsoftonline.com/${msTenantId}`,
      redirectUri: currenthost,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: any, message: any, containsPii: any) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
            default:
              return;
          }
        },
      },
    },
  };
};

export const loginRequest = {
  scopes: ['User.Read'],
  prompt: 'select_account'
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
